import React from "react";
import { Button, Overlay, OverlayTrigger, Popover } from "react-bootstrap";
import { ChromePicker } from "react-color";

import styles from "./color.module.scss";

interface ColorPickerProps {
  children: React.ReactNode;
  color: string;
  onChange: (color: string) => void;
  onClose?: () => void;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({ children, color, onChange, onClose }) => {

  return (
    <OverlayTrigger trigger="click" placement="auto" overlay={
      <Popover id="popover-color-picker" className={styles.colorPickerPopover}>
        <Popover.Body>
          <ChromePicker className={styles.colorPicker} color={color} onChange={onChange} />
        </Popover.Body>
      </Popover>
    } rootClose onExited={() => {
      if(onClose){
        onClose();
      }
    }}>
      {React.isValidElement(children) ? children : <span>{children}</span>}
    </OverlayTrigger>
  );
}